import { useState, useEffect, useRef } from "react";
import { RefObject } from "react";

const usePositionRelativeToParent = (
  offsetX = 0,
  offsetY = 0
): [RefObject<HTMLDivElement>, { top: number; left: number }] => {
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });

  const updatePosition = () => {
    if (ref.current) {
      const parentRect = ref.current.parentElement!.getBoundingClientRect();
      const childRect = ref.current.getBoundingClientRect();

      setPosition({
        top: parentRect.top - childRect.height - offsetY,
        left: parentRect.left + offsetX,
      });
    }
  };

  const findScrollableParent = (element: HTMLElement | null): HTMLElement | null => {
    if (!element) {
      return null;
    }

    const overflowX = window.getComputedStyle(element).overflowX;
    const isScrollable = overflowX === "auto" || overflowX === "scroll";

    if (isScrollable) {
      return element;
    } else {
      return findScrollableParent(element.parentElement);
    }
  };

  useEffect(() => {
    updatePosition();
  }, [offsetX, offsetY]);

  useEffect(() => {
    const handleScroll = () => {
      console.log("scroll");
      updatePosition();
    };

    const scrollableParent = findScrollableParent(ref.current?.parentElement || null);

    window.addEventListener("scroll", handleScroll);
    if (scrollableParent) {
      scrollableParent.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollableParent) {
        scrollableParent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return [ref, position];
};

export default usePositionRelativeToParent;
